/**
 * usePresenceHeartbeat — fires anonymous-or-identified heartbeat every 30s.
 * Mounted once at the app root.
 */
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "./auth";

const KEY = "ssc_pres_sid";
function sessionId() {
  try {
    let id = sessionStorage.getItem(KEY);
    if (!id) {
      id = Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem(KEY, id);
    }
    return id;
  } catch { return "anon-" + Math.random().toString(36).slice(2); }
}

export default function usePresenceHeartbeat() {
  const loc = useLocation();
  const { user } = useAuth();
  const tickRef = useRef(null);

  useEffect(() => {
    // Don't track dealer staff — only customers
    if (user && (user.role === "owner" || user.role === "dealer"
        || user.role === "gm" || user.role === "manager"
        || user.role === "salesperson")) return;
    const sid = sessionId();
    const ping = () => {
      const vehMatch = loc.pathname.match(/\/vehicle\/([^/]+)/);
      api.post("/presence/heartbeat", {
        session_id: sid,
        page: loc.pathname,
        vehicle_id: vehMatch ? vehMatch[1] : null,
        user_id: user?.id,
        name: user?.name,
      }).catch(() => {});
    };
    ping();
    tickRef.current = setInterval(ping, 30000);
    return () => clearInterval(tickRef.current);
  }, [loc.pathname, user]);
}
